import axios from "axios";

const API_PATH = '/manage/event';

const FetchPointSource = async searches => (
	await axios.get(`${API_PATH}/point`, { params: searches })
);

const FetchPointMemberSource = async searches => (
	await axios.get(`${API_PATH}/point/member`, { params: searches })
);

const RemovePointEvent = async epId => (
	await axios.delete(`${API_PATH}/point/${epId}`)
);

const CreateEventPoint = async source => (
	await axios.post(`${API_PATH}/point`, source)
);

const GiveEventPoints = async source => (
	await axios.post(`${API_PATH}/point/member`, source)
);

const EditEventPoint= async ({ epId, source }) => (
	await axios.put(`${API_PATH}/point/${epId}`, source)
);

const FetchGroupSource = async searches => (
	await axios.get(`${API_PATH}/group`, { params: searches })
);

const FetchGroupViewSource = async ({ id }) => (
	await axios.get(`${API_PATH}/group/${id}`)
);

const FetchGroupLevelSource = async ({ id, source }) => (
	await axios.get(`${API_PATH}/group/level/${id}`, { params: source })
);

const FetchGroupTeamSource = async ({ id, source }) => (
	await axios.get(`${API_PATH}/group/team/${id}`, { params: source })
);

const RemoveGroupEvent = async egId => (
	await axios.delete(`${API_PATH}/group/${egId}`)
);

const CreateEventGroup = async source => (
    await axios.post(`${API_PATH}/group`, source, {headers: { 'Content-Type': 'multipart/form-data' }})
)

const SettingMaxGroupNum = async source => (
	await axios.put(`${API_PATH}/group/max-team-size`, source)
);

export { FetchPointSource, FetchPointMemberSource, RemovePointEvent, CreateEventPoint, GiveEventPoints, EditEventPoint, FetchGroupSource, FetchGroupViewSource, FetchGroupLevelSource, FetchGroupTeamSource, RemoveGroupEvent, CreateEventGroup, SettingMaxGroupNum } ;
